module.exports = __webpack_public_path__ + "static/media/logo_cloud.44a57ecc.png";